import { type Vector3 } from '@canvas/vector-types';

import {
  b700,
  b200,
  backgroundAccentBlueSubtlestHovered,
  r700,
  red,
  backgroundAccentRedSubtlestHovered,
  p700,
  p200,
  backgroundAccentPurpleSubtlestHovered,
  g700,
  g150,
  backgroundAccentGreenSubtlestHovered,
  t700,
  teal,
  backgroundAccentTealSubtlestHovered,
  m700,
  m200,
  backgroundAccentMagentaSubtlestHovered,
  o700,
  orange,
  backgroundAccentOrangeSubtlestHovered,
  y700,
  y150,
  backgroundAccentYellowSubtlestHovered,
  l700,
  l200,
  backgroundAccentLimeSubtlestHovered,
} from '../colors';
import { type ColorName } from '../colors/color-names';
import { type BackgroundColorToken, type TokenName } from '../colors/tokens-types';

interface CollaboratorColor {
  telepointerColorToken: BackgroundColorToken;
  telepointerFallbackColor: Vector3;
  stickyColor: Vector3;
  colorName: ColorName;
  // For the background of anonymous SVG avatars
  svgBackgroundColorToken: TokenName;
  svgBackgroundFallbackColor: Vector3;
}

/**
 * Telepointers have a higher intensity for contrast vs.
 * background color
 */
export const telepointerColors: Array<CollaboratorColor> = [
  {
    telepointerColorToken: 'color.background.accent.blue.bolder',
    telepointerFallbackColor: b700,
    stickyColor: b200,
    colorName: 'b200',
    svgBackgroundColorToken: 'color.background.accent.blue.subtlest.hovered',
    svgBackgroundFallbackColor: backgroundAccentBlueSubtlestHovered,
  },
  {
    telepointerColorToken: 'color.background.accent.red.bolder',
    telepointerFallbackColor: r700,
    stickyColor: red,
    colorName: 'red',
    svgBackgroundColorToken: 'color.background.accent.red.subtlest.hovered',
    svgBackgroundFallbackColor: backgroundAccentRedSubtlestHovered,
  },
  {
    telepointerColorToken: 'color.background.accent.purple.bolder',
    telepointerFallbackColor: p700,
    stickyColor: p200,
    colorName: 'p200',
    svgBackgroundColorToken: 'color.background.accent.purple.subtlest.hovered',
    svgBackgroundFallbackColor: backgroundAccentPurpleSubtlestHovered,
  },
  {
    telepointerColorToken: 'color.background.accent.green.bolder',
    telepointerFallbackColor: g700,
    stickyColor: g150,
    colorName: 'g150',
    svgBackgroundColorToken: 'color.background.accent.green.subtlest.hovered',
    svgBackgroundFallbackColor: backgroundAccentGreenSubtlestHovered,
  },
  {
    telepointerColorToken: 'color.background.accent.teal.bolder',
    telepointerFallbackColor: t700,
    stickyColor: teal,
    colorName: 'teal',
    svgBackgroundColorToken: 'color.background.accent.teal.subtlest.hovered',
    svgBackgroundFallbackColor: backgroundAccentTealSubtlestHovered,
  },
  {
    telepointerColorToken: 'color.background.accent.magenta.bolder',
    telepointerFallbackColor: m700,
    stickyColor: m200,
    colorName: 'm200',
    svgBackgroundColorToken: 'color.background.accent.magenta.subtlest.hovered',
    svgBackgroundFallbackColor: backgroundAccentMagentaSubtlestHovered,
  },
  {
    telepointerColorToken: 'color.background.accent.orange.bolder',
    telepointerFallbackColor: o700,
    stickyColor: orange,
    colorName: 'orange',
    svgBackgroundColorToken: 'color.background.accent.orange.subtlest.hovered',
    svgBackgroundFallbackColor: backgroundAccentOrangeSubtlestHovered,
  },
  {
    telepointerColorToken: 'color.background.accent.yellow.bolder',
    telepointerFallbackColor: y700,
    stickyColor: y150,
    colorName: 'y150',
    svgBackgroundColorToken: 'color.background.accent.yellow.subtlest.hovered',
    svgBackgroundFallbackColor: backgroundAccentYellowSubtlestHovered,
  },
  {
    telepointerColorToken: 'color.background.accent.lime.bolder',
    telepointerFallbackColor: l700,
    stickyColor: l200,
    colorName: 'l200',
    svgBackgroundColorToken: 'color.background.accent.lime.subtlest.hovered',
    svgBackgroundFallbackColor: backgroundAccentLimeSubtlestHovered,
  },
];
